import book from './book.json';

export default book;
